// Copyright 2026, Imprivata, Inc.  All rights reserved.

import { DownloadOutlined } from '@ant-design/icons';
import { Button } from '@imprivata-cloud/components';
import { downloadAsFileToUserComputer } from '@utils/utils';
import { useTranslation } from 'react-i18next';
import { formatCertAsPem } from '../utils/pem';

interface DownloadCertButtonProps {
  idpCertificate: string;
  tenantId: string;
}

const TRANSLATION_ROOT = 'apps.app-modal';

const DownloadCertButton: React.FC<DownloadCertButtonProps> = ({ idpCertificate, tenantId }) => {
  const { t } = useTranslation();

  const handleDownload = () => {
    const pem = formatCertAsPem(idpCertificate);
    const blob = new Blob([pem], { type: 'application/x-pem-file' });
    const filename = t(`${TRANSLATION_ROOT}.download-filename`, { tenantId });
    downloadAsFileToUserComputer(blob, filename);
  };

  return (
    <Button type="default" size="small" icon={<DownloadOutlined />} onClick={handleDownload}>
      {t(`${TRANSLATION_ROOT}.certificate-label`)}
    </Button>
  );
};

export default DownloadCertButton;
